import { makeAutoObservable, runInAction } from 'mobx';
import agent from '../api/agent';
import { toast } from 'react-toastify';
import {
  ReceivingDelivery,
  ReceivingDeliveryDelete,
} from '../models/ReceivingDelivery';
import { store } from './store';
import { acquisitionScanType, registerScanResponse } from '../api/types';

export default class ReceivingDeliveryStore {
  receivingdeliveryRegistry = new Map<string, ReceivingDelivery>();
  selectedReceivingDelivery: ReceivingDelivery | undefined = undefined;
  loading = false;
  loadingInitial = false;
  loadingInitialReceiving = false;
  registerScanned: registerScanResponse = {
    typeId: '',
    typeName: '',
    elementId: '',
    elementName: '',
    departmentId: '',
    departmentName: '',
    registerId: '',
    templateId: '',
  };
  constructor() {
    makeAutoObservable(this);
  }

  get receivingsdeliveries() {
    return Array.from(this.receivingdeliveryRegistry.values()).filter(
      (a) => a.isDeleted === false,
    );
  }
  private setReceivingDelivery = (receiving: ReceivingDelivery) => {
    this.receivingdeliveryRegistry.set(receiving.id, receiving);
  };

 
  setLoadingInitial = (state: boolean) => {
    this.loadingInitial = state;
  };

  loadReceivingsDeliveriesPagination = async (pagenum: number) => {
    this.loadingInitial = true;
    try {
      //  ======= This is Receiving verify pagenation resovled by kumaresan
      if (pagenum === 1) store.dashboardStore.setRegisterPageNum(pagenum);

      this.receivingdeliveryRegistry = new Map<string, ReceivingDelivery>();
      let receivingdelivery: any[] =
        await agent.ReceivingsDeliveries.listPagination(pagenum, 5);
      receivingdelivery = receivingdelivery?.map((obj: any) => {
        obj[`Mode_of_Transport`] = obj[`courier`];
        obj[`Mode_of_Transport_Number`] = obj[`courier_Number`];
        delete obj[`courier_Number`];
        delete obj[`courier`];
        return obj;
      });
      runInAction(() => {
        receivingdelivery.forEach((receivedeliver) => {
          this.setReceivingDelivery(receivedeliver);
        });
      });
      this.setLoadingInitial(false);
    } catch (error) {
      runInAction(() => {
        console.log(error);
        this.setLoadingInitial(false);
      });
    }
  };
  searchListReceiving = async (pagenum: number, data: any) => {
    this.loadingInitial = true;
    try {
      this.receivingdeliveryRegistry = new Map<string, ReceivingDelivery>();
      let params = {
        PageNumber: pagenum,
        PageSize: 5,
        receiving: JSON.stringify(data),
      };
      const receivingdelivery =
        await agent.ReceivingsDeliveries.searchList(params);
      const countData = await agent.ReceivingsDeliveries.searchCountReceiving(
        JSON.stringify(data),
      );
      if (pagenum === 1) {
        store.dashboardStore.setCRTablePageNumFunc(1);
        store.dashboardStore.dashboard.setRegisterPageNumber = 1;
      }
      runInAction(() => {
        store.dashboardStore.dashboard.receivingsCount = countData;
        receivingdelivery.data.forEach((receivedeliver) => {
          this.setReceivingDelivery(receivedeliver);
        });
      });
      this.setLoadingInitial(false);
    } catch (error) {
      runInAction(() => {
        console.log(error);
        this.setLoadingInitial(false);
      });
    }
  };
  sortReceivingList = async (data: any, direction: string, pagenum: number) => {
    this.loadingInitial = true;
    try {
      const receivingdelivery = await agent.ReceivingsDeliveries.sortList(
        data,
        direction,
        pagenum,
      );
      this.receivingdeliveryRegistry = new Map<string, ReceivingDelivery>();

      runInAction(() => {
        receivingdelivery.data.forEach((receivedeliver) => {
          this.setReceivingDelivery(receivedeliver);
        });
      });
      this.setLoadingInitial(false);
    } catch (error) {
      runInAction(() => {
        console.log(error);
        this.setLoadingInitial(false);
      });
    }
  };

  loadReceivingDelivery = async (id: string) => {
    let receivingdelivery = this.getReceivingDelivery(id);
    if (receivingdelivery) {
      this.selectedReceivingDelivery = receivingdelivery;
      return receivingdelivery;
    } else {
      this.loadingInitial = true;
      try {
        receivingdelivery = await agent.ReceivingsDeliveries.details(id);
        this.setReceivingDelivery(receivingdelivery);
        runInAction(() => {
          this.selectedReceivingDelivery = receivingdelivery;
        });
        this.setLoadingInitial(false);
        this.loadingInitial = false;
        return receivingdelivery;
      } catch (error) {
        console.log(error);
        this.setLoadingInitial(false);
      }
    }
  };

  // loadHFCShipper = async (id: string) => {
  //   let HFCShipperInfotemp = this.getHFCShipper(id);
  //   if (HFCShipperInfotemp) {
  //     this.selectedHFCShipper = HFCShipperInfotemp;
  //     return HFCShipperInfotemp;
  //   } else {
  //     this.loadingInitial = true;
  //     try {
  //       const response: AxiosResponse<HFCShipperInfo> = await agent.HFC.HFCShipperSelected(id);
  //       HFCShipperInfotemp = response.data; // Access the 'data' property
  //       this.setHFCShipper(HFCShipperInfotemp);
  //       runInAction(() => {
  //         this.selectedHFCShipper = HFCShipperInfotemp;
  //       });
  //       this.setLoadingInitial(false);
  //       this.loadingInitial = false;
  //       return HFCShipperInfotemp;
  //     } catch (error) {
  //       console.log(error);
  //       this.setLoadingInitial(false);
  //     }
  //   }
  // }
  
  setRecevindDeliveryAsUndefined = () => {
    this.selectedReceivingDelivery = undefined;
  };

  private getReceivingDelivery = (id: string) => {
    return this.receivingdeliveryRegistry.get(id);
  };

  

  createReceivingDelivery = async (receivingdelivery: ReceivingDelivery) => {
    this.loading = true;
    try {
      await agent.ReceivingsDeliveries.create(receivingdelivery);
      //  store.dashboardStore.dashboard.receivingsCount += 1;
      await agent.updateCountOrder.updateCount(
        store?.userStore?.user?.id || '',
      );
      runInAction(() => {
        this.receivingdeliveryRegistry.set(
          receivingdelivery.id,
          receivingdelivery,
        );
        //this.editMode = false;
        this.loading = false;
      });
      toast.success('Package Record Created Successfully');
    } catch (error) {
      console.log(error);
      runInAction(() => {
        this.loading = false;
      });
    }
  };

  updateReceivingDelivery = async (
    receivingdelivery: ReceivingDelivery,
    value: string,
  ) => {
    this.loadingInitial = true;

    try {
      await agent.ReceivingsDeliveries.updateReceivings(receivingdelivery);

      runInAction(() => {
        this.receivingdeliveryRegistry.set(
          receivingdelivery.id,
          receivingdelivery,
        );
      });
      if (value !== 'FromVerify') {
        toast.success('Package Record  updated succesfully.');
      } else {
        toast.success('Package Record  updated succesfully.');
      }
      this.loading = false;
    } catch (error) {
      console.log(error);
      runInAction(() => {
        this.loadingInitial = false;
      });
    }
  };
  deleteReceivingDelivery = async (
    ReceivingDelivery: ReceivingDeliveryDelete,
  ) => {
    this.loadingInitialReceiving = true;
    try {
      await agent.ReceivingsDeliveries.delete(ReceivingDelivery);
      this.receivingdeliveryRegistry = new Map<string, ReceivingDelivery>();
      runInAction(() => {
        // this.receivingdeliveryRegistry.delete(ReceivingDelivery.id);
        // store.dashboardStore.dashboard.receivingsCount -= 1;
        setTimeout(() => {
          store.dashboardStore.setRegisterPageNum(1);
          store.dashboardStore.receivingCount();
          this.loadReceivingsDeliveriesPagination(1);
          this.loadingInitialReceiving = false;
        }, 500);
      });
      toast.success('Deleted Succesfully');
    } catch (error) {
      this.loadingInitial = false;
      runInAction(() => {
        console.log(error);
        this.loadingInitialReceiving = false;
      });
    }
  };
  deleteFile = async (id: string) => {
    try {
      await agent.ReceivingsDeliveries.deleteFile(id);
    } catch (error) {
      runInAction(() => {
        console.log(error);
      });
    }
  };

  registerScanData = async (payload: acquisitionScanType) => {
    try {
      const response = await agent.NFAI.registerScanData(payload);
      runInAction(() => {
        this.registerScanned = response.data;
      });
      return response.data;
    } catch (error) {
      toast.error('Failed to scan data.');
      console.log('API Failed: ', error);
    }
  };

  addItemGroupAcquisition = async (
    payload: string[],
    params: { customer: string },
  ) => {
    try {
      const response = await agent.NFAI.addItemGroupAcquisition(
        payload,
        params,
      );
      return response.data;
    } catch (error) {
      toast.error('Failed to add item group');
      console.log('API Failed: ', error);
    }
  };

  createItemAcquisition = async (
    payload: any,
    params: { itemGroupId: string; title: string },
  ) => {
    try {
      await agent.NFAI.createItemAcquisition(payload, params);
    } catch (error) {
      toast.error('Failed to create item(s)');
      console.log('API Failed: ', error);
    }
  };

  updateDashboardCountNFAI = async (params: {
    itemCount: number;
    taskCount: number;
  }) => {
    try {
      await agent.NFAI.updateCountPostBatchUpload(params);
      runInAction(() => {
        toast.info('Production Count updated Successfully.');
      });
    } catch (error) {
      toast.error('Failed to update count');
      console.log('API Failed: ', error);
    }
  };
}
